import React from 'react';
import { API_BASE_URL as API_URL } from '../utils/api';

const PostImageGallery = ({ images }) => {
  if (!images || images.length === 0) return null;

  const getFullUrl = (path) => `${API_URL}${path}`;

  const gridClass = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-2 sm:grid-cols-3',
    4: 'grid-cols-2',
    5: 'grid-cols-2 sm:grid-cols-3',
  }[images.length] || 'grid-cols-2';

  return (
    <div className={`grid ${gridClass} gap-2`}>
      {images.map((img, idx) => (
        <a
          key={idx}
          href={getFullUrl(img)}
          target="_blank"
          rel="noopener noreferrer"
          className="block overflow-hidden rounded-lg border border-gray-200 hover:opacity-90 transition-opacity"
        >
          <img
            src={getFullUrl(img)}
            alt={`Attachment ${idx + 1}`}
            className="w-full h-48 object-cover"
            onError={(e) => {
              if (e.currentTarget.dataset.fallback !== '1') {
                e.currentTarget.dataset.fallback = '1';
                e.currentTarget.src = '/no_image.webp';
              }
            }}
          />
        </a>
      ))}
    </div>
  );
};

export default PostImageGallery;
